import React from 'react';
import walkingDodoBirds from '../../assets/gifs/walking_dodo_birds.gif';

/**
 * 로딩 스피너 컴포넌트
 * DynamicTable과 DynamicForm에서 사용되는 공통 로딩 표시 컴포넌트
 * 
 * @param {string} message - 로딩 메시지 (기본값: '데이터를 불러오는 중...')
 * @param {string} size - 이미지 크기 ('sm' | 'md' | 'lg') 기본값: 'md'
 * @param {string} className - 추가 CSS 클래스
 */
const LoadingSpinner = ({ 
  message = '데이터를 불러오는 중...', 
  size = 'md',
  className = '' 
}) => {
  
  const sizeClasses = {
    sm: 'w-16 h-16',
    md: 'w-24 h-24',
    lg: 'w-32 h-32'
  };

  return (
    <div className={`flex flex-col items-center justify-center h-64 bg-white dark:bg-gray-800 border dark:border-gray-700 rounded-lg ${className}`}>
      <div className="flex flex-col items-center gap-4">
        {/* 도도새 걷는 GIF */}
        <img 
          src={walkingDodoBirds} 
          alt="Loading..." 
          className={sizeClasses[size]}
          style={{
            imageRendering: 'auto',
            objectFit: 'contain'
          }}
        />
        
        {/* 스피너 */}
        <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600"></div>
        
        {/* 로딩 메시지 */}
        <span className="text-gray-600 dark:text-gray-300">{message}</span>
      </div>
    </div>
  );
};

export default LoadingSpinner;
